import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-empresascertificadas',
  templateUrl: './empresascertificadas.component.html',
  styleUrls: ['./empresascertificadas.component.css']
})
export class EmpresascertificadasComponent implements OnInit {
  jsonArrayDescricao: any;
  jsonArray:any;
  descricao: string = '';
  lat = 0;
  long = 0;
  zoom = 0;
  markers = [];

  constructor(private apiService: ApiService, private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit() {
    this.carregarLista();
  }

  carregarAvaliacao(e){
    this.router.navigate(['/classificacao', e.lojistaid]);
  }

  abrirMapa(e){
    //console.log(e);
    this.router.navigate(['/maps', e.estado], { replaceUrl: true });
  }

  changeTab(e){
    if(e.id === "tab1"){
      this.carregarLista()
    }else if(e.id === "tab2"){
      this.carregarRanking();
    }else{
      this.carregarMapa();
    }
  }

  carregarLista(){
    this.jsonArrayDescricao = [];
    this.spinner.show();
    this.apiService.getListagem('lojistascertificados')
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayDescricao = data;

          this.spinner.hide();

          //this.getGeolocation();

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          console.log(JSON.parse(JSON.stringify(error)));
        },() => {
          this.spinner.hide();
        }
      );
  }

  carregarRanking(){
    this.jsonArrayDescricao = [];
    this.spinner.show();
    this.apiService.getListagem('lojistasranking')
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayDescricao = data;

          this.spinner.hide();

          //this.getGeolocation();

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          console.log(JSON.parse(JSON.stringify(error)));
        },() => {
          this.spinner.hide();
        }
      );
  }

  carregarMapa(){
    this.jsonArray = [];
    this.apiService.getListagem('lojistasgpsbr')
      .subscribe(
        (data) => { //start of (1)

          this.jsonArray = data;

          for (var i = 0; i < this.jsonArray.length; i++) {
            var endereco = this.jsonArray[i].endereco + ", Nº " + this.jsonArray[i].numero;
            var cidade = this.jsonArray[i].cidade + "-" + this.jsonArray[i].estado;
            this.markers.push({
              lat: this.jsonArray[i].latitude, lng: this.jsonArray[i].longetude, label: this.jsonArray[i].nome, icon: this.jsonArray[i].iconmapa,
              endereco: endereco, cidade: cidade
            })
          }

          this.visualizarMapa();

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          console.log(JSON.parse(JSON.stringify(error)));
        },() => {
          this.spinner.hide();
        }
      );
  }

  visualizarMapa() {
    this.lat = Number(-14.2350);
    this.long = Number(-51.9253);
    this.zoom = 4;

    //console.log(Number(this.lat));

    this.spinner.hide();
  }
}
